import React from "react";
import HeaderAd from "./HeaderAd";

export default function HeroSection({ title, description }) {
  return (
    <section className="bg-purple-700">
      <div className="container mx-auto p-2 text-white py-12 md:py-20">
        <div className="flex flex-wrap items-center">
          <div className="w-full md:w-2/3 pr-8">
            <h1 className="text-lg font-medium uppercase">{title}</h1>
            <p className="text-3xl md:text-4xl font-semibold">{description}</p>
          </div>
          <div className="w-full md:w-1/3 mt-8 md:mt-0">
            <HeaderAd />
          </div>
        </div>
      </div>
    </section>
  );
}
